import { Table, Group, UnstyledButton, Text, Center } from '@mantine/core';
import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';
import type { SortDirection } from '@/hooks/useTableSort';

interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSortKey: string | null;
  currentDirection: SortDirection;
  onSort: (key: string) => void;
}

export function SortableTableHeader({
  label,
  sortKey,
  currentSortKey,
  currentDirection,
  onSort,
}: SortableTableHeaderProps) {
  const isSorted = currentSortKey === sortKey;

  return (
    <Table.Th>
      <UnstyledButton onClick={() => onSort(sortKey)} style={{ width: '100%' }}>
        <Group gap={4} wrap="nowrap">
          <Text fw={700} size="sm">
            {label}
          </Text>
          <Center>
            {isSorted ? (
              currentDirection === 'asc' ? (
                <IconChevronUp size={14} />
              ) : (
                <IconChevronDown size={14} />
              )
            ) : (
              <IconSelector size={14} opacity={0.3} />
            )}
          </Center>
        </Group>
      </UnstyledButton>
    </Table.Th>
  );
}
